// extracted by mini-css-extract-plugin
export default {"departments":"MG-z","departmentHeading":"NG-z","departmentSection":"OG-z","departmentName":"PG-z","departmentLink":"QG-z","expandIcon":"RG-z"};